import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { gotoUrl } from "@menu/core/lib";

const CartIcon = observer((props: ContextProps) => {
  const { cart } = props.context;
  const { display, url, cartItems } = cart;

  if (!display) {
    return null;
  }

  return (
    <span className="inbox-icon">
      <i className="icon-supermarket_32x32" onClick={() => gotoUrl(url)} />
      {cartItems > 0 && <i className="unread-count">{cartItems}</i>}
    </span>
  );
});

export default CartIcon;
